/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { maintainContractActions } from '../../store/actions';

export default (props) => {
  const { colId } = props.column;
  const { hasAccess, isEnablebyRole } = props;
  // handing Onchange event & check validation on filed level
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const commonDropdownList = useSelector((state) => {
    return state.sharedState.ContractReducer.fetchAllCommonContractDFDropdowns;
  });
  const marketBasketList = useSelector((state) => {
    return state.sharedState.ContractReducer.marketBasketName;
  });
  // Handling on changes in the select box
  const handleChangeSelect = (e) => {
    props.node.setDataValue(colId, e.target.value);
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
  };

  // React.useEffect(() => {
  //   dispatch(getReferences([colId], colId));
  // }, []);

  return (
    <div data-testid="check-log-select-box">
      <TextField
        label={`label_${colId}`}
        id={`label_${colId}`}
        className="frr-display-hidden-label"
        inputProps={{ id: `label_${colId}` }}
        fullWidth
        select
        placeholder=""
        InputLabelProps={{
          shrink: true,
        }}
        value={props.value ? props.value : '-1'}
        onChange={(e) => {
          handleChangeSelect(e);
        }}
        disabled={hasAccess === false || isEnablebyRole === false}
      >
        <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
        {colId === 'basketname'
          ? marketBasketList &&
            marketBasketList?.map((res, index) => (
              <MenuItem value={res} key={index}>
                {res}
              </MenuItem>
            ))
          : colId === 'REBATE_PRICING_METHOD_CD'
          ? commonDropdownList?.REBATE_PRICING_METHOD_CD &&
            commonDropdownList?.REBATE_PRICING_METHOD_CD.map((res, index) => (
              <MenuItem value={res?.codeValueID?.codeValue} key={index}>
                {res.codeValueID?.codeValue} : {res.shortDescription}
              </MenuItem>
            ))
          : colId === 'VOLUME_CALC_METHOD_CD'
          ? commonDropdownList?.VOLUME_CALC_METHOD_CD &&
            commonDropdownList?.VOLUME_CALC_METHOD_CD.map((res, index) => (
              <MenuItem value={res?.codeValueID?.codeValue} key={index}>
                {res.codeValueID?.codeValue} : {res.shortDescription}
              </MenuItem>
            ))
          : colId === 'MKT_SHARE_CALC_METHOD_CD'
          ? commonDropdownList?.MKT_SHARE_CALC_METHOD_CD &&
            commonDropdownList?.MKT_SHARE_CALC_METHOD_CD.map((res, index) => (
              <MenuItem value={res?.codeValueID?.codeValue} key={index}>
                {res.codeValueID?.codeValue} : {res.shortDescription}
              </MenuItem>
            ))
          : commonDropdownList?.NAT_MKT_SHARE_TYPE_CD &&
            commonDropdownList?.NAT_MKT_SHARE_TYPE_CD.map((res, index) => (
              <MenuItem value={res?.codeValueID?.codeValue} key={index}>
                {res.codeValueID?.codeValue} : {res.shortDescription}
              </MenuItem>
            ))}
      </TextField>
    </div>
  );
};
